import api from '../../plugins/api';

const getDealPaymentTypes = (params) => {
  return api.get('/api/crm/deals/getDealPaymentTypes', params);
};

export default getDealPaymentTypes;
